import Pusher from 'pusher-js';

export const pusher = new Pusher('19b66e3140a55bf0a514', {
    cluster: 'ap2',
    encrypted: true
});